package com.exura.util

import com.exura.features.localization.commonLocalization
import com.exura.pages.settings.profileLocalization
import com.exura.common.domain.validation.StringValidationState
import com.exura.common.domain.validation.email.EmailValidator

object StringValidator {

    private const val EMAIL_REGEX = """^[\w.%+-]+@[\w.-]+\.[A-Za-z]{2,}${'$'}"""
    private const val PHONE_NUMBER_REGEX =
        """^\+?(\d{1,3})?[-.\s]?(\(?\d{3}\)?)?[-.\s]?\d{3}[-.\s]?\d{4}${'$'}"""

    fun getEmptyFieldError(value: String): String = if (value.isBlank()) {
        profileLocalization.current.errors.fieldCantBeEmpty
    } else {
        ""
    }

    fun getEmailError(email: String): String = when (EmailValidator.validateEmail(email)) {
        StringValidationState.Error.Empty -> profileLocalization.current.errors.emailCantBeEmpty
        StringValidationState.Error.Invalid -> profileLocalization.current.errors.provideCorrectEmail
        StringValidationState.Success -> ""
    }

    fun getPhoneNumberError(phoneNumber: String): String = when {
        phoneNumber.isBlank() -> profileLocalization.current.errors.phoneNumberCantBeEmpty
        !Regex(PHONE_NUMBER_REGEX).matches(phoneNumber.trim()) -> profileLocalization.current.errors.provideCorrectPhoneNumber
        else -> ""
    }
}
